import React, {useEffect, useMemo, useState} from "react";
import {Divider, FlexboxGrid, Loader} from "rsuite";
import BasicStatBox from "../../dashboard/BasicStatBox";
import {BarChart, Bars} from '@rsuite/charts';
import {getAdminDashboard} from "../../../service/adminService";
import PieChartWrapper from "../../charts/PieChartWrapper";

const style = {
    paddingTop: '50px',
};

const stackedStatBoxStyle = {
    marginTop: '5px',
}

const AdminDashboard = () => {

    const [adminData, setAdminData] = useState({});
    const [degreeChartData, setDegreeChartData] = useState([]);
    const [skillChartData, setSkillChartData] = useState([]);
    const [toolRoleChartData, setToolRoleChartData] = useState([]);
    const [userExpChartData, setUserExpChartData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAdminDashboard().then((response) => {
            setAdminData(response);
            let skills = [];
            for (let skillType in response.skillCounts) {
                // for each type, sort the skills and keep the top 10 for graph display
                //get counts to test out charting  library
                skills.push([skillType, response.skillCounts[skillType].sort((a, b) => {
                    return b[1] - a[1];
                }).slice(0,10)]);
            }
            skills.sort((a, b) => {
                return a[0].localeCompare(b[0], undefined);
            });
            setSkillChartData(skills);

            let degrees = [];
            for (let degree in response.degreeCounts) {
                degrees.push([degree, response.degreeCounts[degree]]);
            }
            degrees.sort((a, b) => {
                return b[1] - a[1];
            });
            setDegreeChartData(degrees);

            let roles = [];
            for (let role in response.toolRoleCounts) {
                roles.push([role, response.toolRoleCounts[role]]);
            }
            setToolRoleChartData(roles);

            let userExp = [];
            for (let exp in response.experienceCounts) {
                userExp.push([exp, response.experienceCounts[exp]]);
            }
            userExp.sort((a, b) => {
                return a[0].localeCompare(b[0], undefined, {numeric: true});
            });
            setUserExpChartData(userExp);
            setLoading(false);
        });
    }, []);

    return useMemo(() => {
        return (
            <>
                {loading  ?  <Loader content="Loading..." size="lg" vertical center /> :
                <div className="main-content">
                    <h2>Welcome, Admin</h2>
                    <FlexboxGrid justify="center" style={style}>
                        <FlexboxGrid.Item colspan={4}>
                            <BasicStatBox
                                header="Total Users"
                                content={adminData.totalUsers}
                            />
                            <BasicStatBox
                                header="Users w/ Experience Filled"
                                content={userExpChartData.map(d => d[1]).reduce((a,b) => a+b, 0)}
                                style={stackedStatBoxStyle}
                            />
                            <BasicStatBox
                                header="Average Employee Tenure" // returned in months for precision
                                content={`${(adminData.avgEmployeeTenure / 12).toFixed(2)} years`}
                                style={stackedStatBoxStyle}
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={14}>
                            <BarChart
                                horizontal
                                data={userExpChartData}
                                name='Employee Experience By Year (Inclusive)'
                            />
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                    <Divider />
                    <FlexboxGrid justify="space-between">
                        <FlexboxGrid.Item colspan={12}>
                            <PieChartWrapper
                                data={degreeChartData}
                                title='Degree Types'
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={12}>
                            <PieChartWrapper
                                data={toolRoleChartData}
                                title='Resume Tool User Roles'
                                donut={true}
                            />
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                    <Divider>Top 10 Skills Per Category</Divider>
                    <FlexboxGrid justify="center">
                    {
                        skillChartData.map(skillType => {
                            const mergedTitleAndCounts = skillType[1].map(skill => skill.count);
                            mergedTitleAndCounts.unshift(skillType[0]);
                          return (
                              <FlexboxGrid.Item colspan={4} key={`${skillType[0]}-flexboxgriditem`}>
                                  <BarChart
                                      data={[mergedTitleAndCounts]}
                                      name={skillType[0]}
                                      key={skillType[0]}
                                      legend={false}
                                  >
                                      {
                                          skillType[1].map(skill => {
                                              return <Bars key={skill.name} name={skill.name} />
                                          })
                                      }
                                  </BarChart>
                              </FlexboxGrid.Item>
                          );
                        })
                    }
                    </FlexboxGrid>
                </div>
                }
            </>
        );
    }, [adminData.avgEmployeeTenure, adminData.totalUsers, degreeChartData, loading, skillChartData, toolRoleChartData, userExpChartData]);
}

export default AdminDashboard;